import { FC } from 'react';
import {
  StyledDialog,
  CloseIconBox,
  HeaderBox,
  AlertIcon,
  TitleText,
  Divider,
  SubtitleText,
  SecondaryText,
  ButtonContainer,
  ConfirmButton,
  CancelButton,
} from './ConfirmationDialogV2.styles';

interface ConfirmationDialogV2Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  subtitle: string;
  subtitleSecondary?: string;
  confirmText?: string;
  confirmButtonColor?: string;
  iconColor?: string;
  loading?: boolean;
}

const ConfirmationDialogV2: FC<ConfirmationDialogV2Props> = ({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  subtitleSecondary,
  confirmText = 'Confirm',
  confirmButtonColor = '#22C55E',
  iconColor = '#FFA500',
  loading = false,
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <CloseIconBox
        component="i"
        className="bx bx-x-circle"
        onClick={onClose}
      />

      <HeaderBox>
        <AlertIcon
          component="i"
          className="bx bx-error-circle"
          iconColor={iconColor}
        />
        <TitleText>{title}</TitleText>
      </HeaderBox>

      <Divider />

      <SubtitleText>{subtitle}</SubtitleText>
      {subtitleSecondary && <SecondaryText>{subtitleSecondary}</SecondaryText>}

      <ButtonContainer>
        <ConfirmButton
          onClick={onConfirm}
          btnColor={confirmButtonColor}
          disabled={loading}
        >
          {confirmText}
        </ConfirmButton>
        <CancelButton onClick={onClose} disabled={loading}>
          Cancel
        </CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default ConfirmationDialogV2;
